import React from "react";

import SectionHeader from "../../components/SectionHeader";
import { GridInputs, Table } from "../../../../../../components/Functional";
import { FETCH_CRM_REGISTRARS_V2 as fetchCRMRegistrarsV2 } from "../../../../../../graphql/query/CRMRegistrar";
import { Button, Modal } from "../../../../../../components/ui";
import AddEditDebtors from "./components/AddEditDebtors";
import Actions from "./components/Actions";
import useUser from "../../../../../../hooks/useUser";

const Debtors = props => {
  const { hasPermission } = useUser();
  const { formik, invoiceId } = props;

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "crmRegistrarsV2",
    headers: [
      { label: "Date", name: "date", type: "date" },
      { label: "Type", name: "type.description", type: "label" },
      {
        label: "Description",
        name: "description",
        type: "label",
        widthInPx: 600,
      },
      { label: "User", name: "user.name", type: "label" },
      {
        label: "",
        name: "actions",
        type: "custom",
        component: Actions,
        invoiceId,
      },
    ],
    inputs: [],
    FETCH_QUERY: fetchCRMRegistrarsV2({ type: {}, user: {} }),
    variables: {
      categoryId: {
        operator: "eq",
        value: 2,
      },
      _invoice: {
        id: {
          operator: "eq",
          value: +invoiceId,
        },
      },
    },
    className: "sm:px-0 lg:px-0",
  };

  const modalProps = {
    body: AddEditDebtors,
    closeOnBackdrop: true,
    invoiceId,
    hideCloseButton: true,
    scale: "md",
  };

  const actions = [
    {
      component: () => {
        return (
          <Modal {...modalProps}>
            <Button label="Add Debtors" action="black" />
          </Modal>
        );
      },
    },
  ];

  const inputs = {
    inputs: [
      {
        className: "grid grid-cols-4 gap-4 mt-5 items-end",
        inputs: [
          {
            designType: "threeStateCheckbox",
            label: "Chase Debt",
            name: "debtChase",
            type: "toggle",
            submitOnBlur: true,
            disabled: !hasPermission("UPDATE_INVOICE_SALES_NOTES"),
          },
        ],
      },
    ],
  };

  const inputProps = {
    formik,
    ...inputs,
  };

  return (
    <div className="w-full">
      <SectionHeader title="Debtors" actions={actions} />
      <div className="w-full px-8 py-4">
        <GridInputs {...inputProps} />
      </div>
      <div className="flex w-full">
        <div className="flex-1">
          <Table {...tableProps} />
        </div>
      </div>
    </div>
  );
};

export default Debtors;
